// Initialised in sentry.html
const Sentry = window.Sentry

export interface SentryUser {
    tenant?: string
    name?: string
    type?: string // User type
    id?: string | number // User ID
    email?: string
}

/**
 * Set user details for Sentry errors
 * @param userDetails
 */
export const setSentryUser = (userDetails: SentryUser) => {
    if (Sentry && Sentry.isInitialized()) {
        Sentry.setUser({
            tenant: userDetails.tenant ?? '-',
            name: userDetails.name ?? '-',
            type: userDetails.type ?? '-',
            id: userDetails.id != null ? String(userDetails.id) : '-',
            email: userDetails.email ?? '-',
        })
    }
}
